<template>
  <v-container>
    <h1>
      <v-icon v-if="!isEdited" class="teams-icon" color="lighten-1" medium
        >mdi-plus</v-icon
      ><v-icon v-else class="teams-icon" color="lighten-1" medium
        >mdi-pencil</v-icon
      >
      <span v-if="!isEdited">Add Promocode</span>
      <span v-else>Edit Promocode </span>
    </h1>

    <v-alert v-if="globalServerErrors !== null" dense outlined type="error">
      <p class="mb-0" v-for="globalErr in globalServerErrors" :key="globalErr">
        {{ globalErr[0] }}
      </p>
    </v-alert>
    <formWrapper :validator="$v.form">
      <form @submit.prevent="handleSave" class="form-box">
        <v-row>
          <v-col cols="12" class="py-0">
            <v-row>
              <!-- <v-col class="mx-auto" cols="12" md="6">
                <section class="increment-label">
                  <span>Capacity</span>
                  <number-input
                    center
                    v-model="form.capacity"
                    :min="1"
                    :step="1"
                    controls
                  ></number-input>
                </section>
              </v-col> -->

              <v-col class="py-0 mx-auto" sm="6" cols="12">
                <form-group name="capacity" :attribute="`fields.capacity`">
                  <template slot-scope="{ attrs, listeners }">
                    <v-text-field
                      v-bind="attrs"
                      v-on="listeners"
                      regular
                      v-model.trim="form.capacity"
                      type="text"
                    >
                    </v-text-field>
                  </template>
                </form-group>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="py-0" sm="6" cols="12">
            <form-group
              name="group_owner_email"
              :attribute="`fields.group_owner_email`"
            >
              <template slot-scope="{ attrs, listeners }">
                <v-text-field
                  v-bind="attrs"
                  v-on="listeners"
                  regular
                  v-model.trim="form.group_owner_email"
                  type="text"
                  :disabled="isEdited"
                >
                </v-text-field>
              </template>
            </form-group>
          </v-col>
          <v-col class="py-0" sm="6" cols="12">
            <form-group name="code" :attribute="`fields.code`">
              <template slot-scope="{ attrs, listeners }">
                <v-text-field
                  v-bind="attrs"
                  v-on="listeners"
                  regular
                  v-model.trim="form.code"
                  type="text"
                  :disabled="true"
                >
                </v-text-field>
              </template>
            </form-group>
          </v-col>
          <v-col class="py-0 dates prepend" cols="12" sm="6">
            <v-dialog
              ref="birthdateDialog"
              v-model="date_modal"
              :return-value.sync="form.expiry_date"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="form.expiry_date"
                  label="Expiry Date"
                  readonly
                  v-on="on"
                  @click:append="clearExpiryDate()"
                  append-icon="mdi-close"
                  prepend-icon="icon-calendar"
                ></v-text-field>
              </template>
              <v-date-picker v-model="form.expiry_date" scrollable>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="date_modal = false"
                  >Cancel</v-btn
                >
                <v-btn
                  text
                  color="primary"
                  @click="$refs.birthdateDialog.save(form.expiry_date)"
                  >OK</v-btn
                >
              </v-date-picker>
            </v-dialog>
          </v-col>
          <v-col class="py-0" sm="6" cols="12">
            <form-group name="discount_id" attribute="fields.discount_id">
              <template slot-scope="{ attrs, listeners }">
                <v-select
                  :loading="loadingData"
                  :items="discounts"
                  item-text="name"
                  item-value="id"
                  regular
                  clearable
                  v-bind="attrs"
                  v-on="listeners"
                  v-model="form.discount_id"
                  :disabled="isEdited"
                ></v-select>
              </template>
            </form-group>
          </v-col>
          <v-col cols="12">
            <section class="transparent-field">
              <v-switch
                v-model="form.is_active"
                inset
                :false-value="0"
                :true-value="1"
                label="Active Code"
                class="mt-0"
                color="success"
              ></v-switch>
            </section>
          </v-col>
          <v-col cols="12">
            <v-btn
              class="success text-capitalize"
              large
              type="submit"
              width="30%"
              :disabled="$v.form.$invalid"
              ><span>Save</span>
            </v-btn>
          </v-col>
        </v-row>
      </form>
    </formWrapper>
  </v-container>
</template>

<script>
import {
  IndexData,
  StoreData,
  ShowData,
  UpdateData
} from "@/helpers/apiMethods";
import { required, email, numeric } from "vuelidate/lib/validators";
export default {
  data() {
    return {
      form: {
        group_owner_email: "",
        code: "",
        capacity: "",
        is_active: 0,
        expiry_date: ""
      },
      discounts: [],
      code: "",
      date_modal: false,
      maxSize: 1.024,
      resetLogo: false,
      Logo: false,
      isEdited: false,
      loadingData: false,
      globalServerErrors: null,
      resetBoolean: false
    };
  },
  created() {
    this.editCreateBoolean();
    this.indexLists();
    // this.generate();
  },
  methods: {
    indexLists() {
      IndexData({ reqName: `/promo-code/lists` })
        .then(res => {
          this.discounts = res.data.discounts;
        })
        .catch(() => {})
        .finally(() => {});
    },
    generate() {
      IndexData({ reqName: `/promo-code/generate` })
        .then(res => {
          // console.log(res);
          this.form.code = res.data.code;
        })
        .catch(() => {})
        .finally(() => {});
    },
    handleSave() {
      if (!this.isEdited) {
        this.createPromoCode();
      } else {
        this.editOnlineCourse();
      }
    },
    editCreateBoolean() {
      if (this.$route.params.id) {
        this.isEdited = true;
      } else {
        this.isEdited = false;
      }
    },
    showData(id) {
      ShowData({
        reqName: `promo-codes`,
        id: id
      })
        .then(res => {
          const { promo_code } = res.data;
          if (promo_code.expiry_date == null) {
            this.form.expiry_date = "";
          }
          this.form = promo_code;
          // if (promo_code.expiry_date !== null) {
          //   this.form.expiry_date = this.$moment(this.form.expiry_date).format(
          //     "YYYY-MM-DD"
          //   );
          // }
        })
        .catch(() => {});
    },
    createPromoCode() {
      const formData = new FormData();
      Object.keys(this.form).forEach(formItem => {
        formData.append(formItem, this.form[formItem]);
      });
      StoreData({
        reqName: `promo-codes`,
        data: formData
      })
        .then(() => {
          history.go(-1);
        })
        .catch(err => {
          this.globalServerErrors = err.response.data.errors;
          this.scrollTop();
        })
        .finally(() => {});
    },
    editOnlineCourse() {
      const formData = new FormData();
      Object.keys(this.form).forEach(formItem => {
        // if (formItem === "date") {
        //   formData.append(formItem, this.form[formItem].date);
        // } else {
        if (this.form[formItem] != null) {
          formData.append(formItem, this.form[formItem]);
          // }
        }
      });
      formData.append("_method", "put");
      UpdateData({
        reqName: `promo-codes`,
        data: formData,
        id: this.$route.params.id
      })
        .then(() => {
          this.isEdited = false;
          history.go(-1);
          this.reset();
        })
        .catch(err => {
          this.globalServerErrors = err.response.data.errors;
          this.scrollTop();
        })
        .finally(() => {});
    },
    reset() {
      this.$v.form.$reset();
      this.$store.dispatch("ClearServerErrors");
    },
    scrollTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    clearExpiryDate() {
      this.form.expiry_date = "";
    }
  },
  watch: {
    $route: {
      handler(route) {
        if (route.name === "promocodesEdit") {
          this.$nextTick(() => {
            this.showData(route.params.id);
          });
        }
        if (route.name === "promocodesCreation") {
          this.generate();
        }
      },
      immediate: true,
      deep: true
    }
  },
  validations: {
    form: {
      capacity: {
        required,
        numeric
      },
      group_owner_email: {
        required,
        email
      },
      discount_id: {
        required
      },
      code: {
        required
      },
      is_active: {
        required
      }
    }
  }
};
</script>
